import { Link } from "@mui/material"; // {Box, Link}
// import AmpFestLogo from "../assets/amp_fest.png";

export default function Logo() {
  return (
    <Link href="/" sx={{ color: "primary.main", textDecoration: "none" }}>
      {/* // @james if you get a logo add back here for mobile */}
      {/* <Box
        component="img"
        sx={[
          {
            width: "auto",
            height: 50,
          },
        ]}
        alt="Amplitude Festival Logo"
        src={AmpFestLogo}
      /> */}
    </Link>
  );
}
